var exports = {
  "kL": "xcc377c0b--3679de--container",
  "zk": "xcc377c0b--3679de--present-info",
  "my": "xcc377c0b--3679de--avatar",
  "DD": "xcc377c0b--3679de--title",
  "Gx": "xcc377c0b--3679de--listing-link",
  "ne": "xcc377c0b--3679de--controls",
};

module.exports = exports;
